import Box from '@mui/material/Box';
import { ReactComponent as CheckIcon } from 'components/v2/Icons/svg/check.svg';

const baseSx = {
  height: 32,
  borderRadius: '128px',
  fontWeight: 500,
  fontSize: '16px',
  textTransform: 'capitalize',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.5,
  px: 1.5,
  cursor: 'pointer',
  userSelect: 'none',
  whiteSpace: 'nowrap',
};

const selectedSx = {
  backgroundColor: 'successGreen.white80',
  border: '1px solid',
  borderColor: 'successGreen.black20',
  color: 'successGreen.black80',
};

const unselectedSx = {
  backgroundColor: 'stoneGrey.white60',
  border: '1px solid',
  borderColor: 'divider',
  color: 'text.primary',
  px: 2.75,
};

export default function SelectableChip({ label, selected, onClick }) {
  return (
    <Box
      onClick={onClick}
      onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), onClick())}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      sx={{ ...baseSx, ...(selected ? selectedSx : unselectedSx) }}
    >
      {selected && <CheckIcon width={16} height={16} />}
      {label}
    </Box>
  );
}
